import * as Sentry from "@sentry/browser";
import { API_DOMAIN, feedbackMessages } from "src/constants/constants";

import { FirebaseUser, AdminTabValue } from "../types/index";

export const getClassNameSidebarTab = (
  activeTab: string | null,
  tabName: AdminTabValue,
) => {
  if (activeTab === tabName) {
    return "secondary-button";
  }

  return "btn-light sidebar";
};

interface RequestOptions {
  endpoint: string;
  method: "POST" | "PUT" | "DELETE" | "GET";
  requestBody: any;
  currentUser: FirebaseUser | null;
  onRequestBegin?: () => void;
  onSuccess: (result: any) => void;
  onError: (error: string) => void;
  onUnauthorised: () => void;
}

export const request = async ({
  endpoint,
  method,
  requestBody,
  onRequestBegin,
  onSuccess,
  onError,
  onUnauthorised,
  currentUser,
}: RequestOptions) => {
  if (onRequestBegin) {
    onRequestBegin();
  }

  const accessToken = await currentUser?.getIdTokenResult();

  try {
    console.log(
      `sending ${method} request to ${endpoint}, with requestBody: `,
      requestBody,
    );

    const response = await fetch(`${API_DOMAIN}${endpoint}`, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        access_token: accessToken?.token,
        ...requestBody,
      }),
    });

    console.log(`response from ${method} request to ${endpoint}`, response);

    if (response.status === 204) {
      console.log(
        `result from ${method} request to ${endpoint}: 204 (No Content)`,
      );
      onSuccess({});
      return;
    }

    const result = await response.json();

    console.log(`result from ${method} request to ${endpoint}`, result);

    if (response.status >= 200 && response.status < 300) {
      onSuccess(result);
    } else if (response.status === 401) {
      onUnauthorised();
    } else {
      Sentry.captureException(result?.error || feedbackMessages.genericError);
      onError(result?.error || feedbackMessages.genericError);
    }
  } catch (error) {
    console.log(`error from ${method} request to ${endpoint}`, error);
    Sentry.captureException(error);

    onError(error as string);
  }
};

export const generateRandomString = (length = 10) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    const randIndex = Math.floor(Math.random() * characters.length);
    result += characters[randIndex];
  }

  return result;
};
